import { render, staticRenderFns } from "./OcorrenciasGerais.vue?vue&type=template&id=26428d4b"
import script from "./OcorrenciasGerais.vue?vue&type=script&lang=js"
export * from "./OcorrenciasGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports